import { render, staticRenderFns } from "./isBanner.vue?vue&type=template&id=37ff4f94&scoped=true&"
import script from "./isBanner.vue?vue&type=script&lang=js&"
export * from "./isBanner.vue?vue&type=script&lang=js&"
import style0 from "./isBanner.vue?vue&type=style&index=0&id=37ff4f94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ff4f94",
  null
  
)

export default component.exports